import * as yup from 'yup';

const defaultMessage = 'Required Field';
yup.setLocale({
  mixed: {
    required: defaultMessage,
  },
  string: {
    min: ({ min }) => `Must be at least ${min} characters`,
    email: 'Invalid email',
  },
  number: {
    integer: 'Must be an integer',
  },
});

const trimString = (value) =>
  typeof value === 'string' ? value.trim() : value;

export const getRefereeSchema = (refereeNumber) => {
  const refKey = `referee${refereeNumber}`;
  const fellowIdKey = `referee${refereeNumber}FellowId`;
  const nonAasKey = `nonAasReferee${refereeNumber}Id`;
  const titleKey = `referee${refereeNumber}TitleId`;
  const nameKey = `referee${refereeNumber}Name`;
  const lastNameKey = `referee${refereeNumber}LastName`;
  const emailKey = `referee${refereeNumber}Email`;
  const countryKey = `referee${refereeNumber}CountryId`;
  const organisationKey = `referee${refereeNumber}Organisation`;
  const educationalInstitutionKey = `referee${refereeNumber}EmailEducationalInstitution`;
  const membershipsKey = `referee${refereeNumber}Memberships`;

  const isNewNonAasReferee = (refValue, nonAasItem) =>
    parseInt(refValue) === 0 &&
    nonAasItem !== undefined &&
    nonAasItem !== null &&
    typeof nonAasItem.value === 'number' &&
    nonAasItem.value === 0;

  return yup.object().shape({
    [refKey]: yup
      .mixed()
      .required(defaultMessage)
      .test(
        'is-valid-selection',
        defaultMessage,
        (value) => value === 0 || value === 1 || value === '0' || value === '1',
      ),
    [fellowIdKey]: yup.object().when(refKey, {
      is: (val) => parseInt(val) === 1,
      then: yup
        .object()
        .nullable()
        .required(defaultMessage)
        .test(
          'not-proposer-seconder-supporter',
          '',
          function notInConflictRole(fellow) {
            if (!fellow || fellow.value === undefined || fellow.value === null) {
              return true;
            }
            const conflictRoleFellows = this.parent?.conflictRoleFellows || {};
            const role = conflictRoleFellows[fellow.value];
            if (!role) {
              return true;
            }
            return this.createError({
              message: `This fellow is already ${role} on this nomination and cannot also be an independent assessor.`,
            });
          },
        ),
      otherwise: yup.object().notRequired().nullable(),
    }),
    [nonAasKey]: yup.object().when(refKey, {
      is: (val) => parseInt(val) === 0,
      then: yup
        .object()
        .nullable()
        .test(
          'has-selected-referee',
          defaultMessage,
          (value) => value != null && value.value != null,
        ),
      otherwise: yup.object().notRequired().nullable(),
    }),
    [titleKey]: yup.number().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.number().required().typeError(defaultMessage),
      otherwise: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? undefined : value))
        .nullable(),
    }),
    [nameKey]: yup.string().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.string().transform(trimString).min(2).max(40).required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    [lastNameKey]: yup.string().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.string().transform(trimString).min(2).max(40).required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    [emailKey]: yup.string().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.string().max(254).email().required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
    [countryKey]: yup.object().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.object().nullable().required(defaultMessage),
      otherwise: yup.object().notRequired().nullable(),
    }),
    [organisationKey]: yup
      .string()
      .when([refKey, nonAasKey, educationalInstitutionKey], {
        is: (refValue, nonAasId, educationalInstitution) =>
          parseInt(refValue) === 0 &&
          nonAasId &&
          typeof nonAasId.value === 'number' &&
          nonAasId.value === 0 &&
          !educationalInstitution,
        then: yup.string().transform(trimString).required(),
        otherwise: yup.string().notRequired().nullable(),
      }),
    [membershipsKey]: yup.string().when([refKey, nonAasKey], {
      is: isNewNonAasReferee,
      then: yup.string().transform(trimString).max(1500).required(),
      otherwise: yup.string().notRequired().nullable(),
    }),
  });
};

const schema = yup.object().shape({});

export default schema;
